// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/service/traveler_service.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_model_path } from "../model/core/model_path_pb";
import { file_proto_model_core_paging } from "../model/core/paging_pb";
import { file_proto_model_core_sort } from "../model/core/sort_pb";
import { file_proto_model_user_traveler } from "../model/user/traveler_pb";

/**
 * Describes the file proto/service/traveler_service.proto.
 */
export const file_proto_service_traveler_service = /*@__PURE__*/
  fileDesc("CiRwcm90by9zZXJ2aWNlL3RyYXZlbGVyX3NlcnZpY2UucHJvdG8SBmNhcm1lbiJgChVDcmVhdGVUcmF2ZWxlclJlcXVlc3QSIwoJdXNlcl9wYXRoGAEgASgLMhAuY2FybWVuLlVzZXJQYXRoEiIKCHRyYXZlbGVyGAIgASgLMhAuY2FybWVuLlRyYXZlbGVyIjwKFkNyZWF0ZVRyYXZlbGVyUmVzcG9uc2USIgoIdHJhdmVsZXIYASABKAsyEC5jYXJtZW4uVHJhdmVsZXIiQQoSR2V0VHJhdmVsZXJSZXF1ZXN0EisKDXRyYXZlbGVyX3BhdGgYASABKAsyFC5jYXJtZW4uVHJhdmVsZXJQYXRoIjkKE0dldFRyYXZlbGVyUmVzcG9uc2USIgoIdHJhdmVsZXIYASABKAsyEC5jYXJtZW4uVHJhdmVsZXIigQEKFExpc3RUcmF2ZWxlcnNSZXF1ZXN0EiMKCXVzZXJfcGF0aBgBIAEoCzIQLmNhcm1lbi5Vc2VyUGF0aBIeCgZwYWdpbmcYAiABKAsyDi5jYXJtZW4uUGFnaW5nEiQKBHNvcnQYAyABKAsyFi5jYXJtZW4uU29ydERlc2NyaXB0b3IiagoVTGlzdFRyYXZlbGVyc1Jlc3BvbnNlEiMKCXRyYXZlbGVycxgBIAMoCzIQLmNhcm1lbi5UcmF2ZWxlchIsCgpwYWdpbmF0aW9uGAIgASgLMhguY2FybWVuLlBhZ2luYXRpb25SZXN1bHQimQEKFVVwZGF0ZVRyYXZlbGVyUmVxdWVzdBIrCg10cmF2ZWxlcl9wYXRoGAEgASgLMhQuY2FybWVuLlRyYXZlbGVyUGF0aBIiCgh0cmF2ZWxlchgCIAEoCzIQLmNhcm1lbi5UcmF2ZWxlchIvCgt1cGRhdGVfbWFzaxgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2siPAoWVXBkYXRlVHJhdmVsZXJSZXNwb25zZRIiCgh0cmF2ZWxlchgBIAEoCzIQLmNhcm1lbi5UcmF2ZWxlciJEChVEZWxldGVUcmF2ZWxlclJlcXVlc3QSKwoNdHJhdmVsZXJfcGF0aBgBIAEoCzIULmNhcm1lbi5UcmF2ZWxlclBhdGgiKQoWRGVsZXRlVHJhdmVsZXJSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIMpoDCg9UcmF2ZWxlclNlcnZpY2USTwoOQ3JlYXRlVHJhdmVsZXISHS5jYXJtZW4uQ3JlYXRlVHJhdmVsZXJSZXF1ZXN0Gh4uY2FybWVuLkNyZWF0ZVRyYXZlbGVyUmVzcG9uc2USRgoLR2V0VHJhdmVsZXISGi5jYXJtZW4uR2V0VHJhdmVsZXJSZXF1ZXN0GhsuY2FybWVuLkdldFRyYXZlbGVyUmVzcG9uc2USTAoNTGlzdFRyYXZlbGVycxIcLmNhcm1lbi5MaXN0VHJhdmVsZXJzUmVxdWVzdBodLmNhcm1lbi5MaXN0VHJhdmVsZXJzUmVzcG9uc2USTwoOVXBkYXRlVHJhdmVsZXISHS5jYXJtZW4uVXBkYXRlVHJhdmVsZXJSZXF1ZXN0Gh4uY2FybWVuLlVwZGF0ZVRyYXZlbGVyUmVzcG9uc2USTwoORGVsZXRlVHJhdmVsZXISHS5jYXJtZW4uRGVsZXRlVHJhdmVsZXJSZXF1ZXN0Gh4uY2FybWVuLkRlbGV0ZVRyYXZlbGVyUmVzcG9uc2VCKlooZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vc2VydmljZWIGcHJvdG8z", [file_google_protobuf_field_mask, file_proto_model_core_model_path, file_proto_model_core_paging, file_proto_model_core_sort, file_proto_model_user_traveler]);

/**
 * Describes the message carmen.CreateTravelerRequest.
 * Use `create(CreateTravelerRequestSchema)` to create a new message.
 */
export const CreateTravelerRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_traveler_service, 0);

/**
 * Describes the message carmen.CreateTravelerResponse.
 * Use `create(CreateTravelerResponseSchema)` to create a new message.
 */
export const CreateTravelerResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_traveler_service, 1);

/**
 * Describes the message carmen.GetTravelerRequest.
 * Use `create(GetTravelerRequestSchema)` to create a new message.
 */
export const GetTravelerRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_traveler_service, 2);

/**
 * Describes the message carmen.GetTravelerResponse.
 * Use `create(GetTravelerResponseSchema)` to create a new message.
 */
export const GetTravelerResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_traveler_service, 3);

/**
 * Describes the message carmen.ListTravelersRequest.
 * Use `create(ListTravelersRequestSchema)` to create a new message.
 */
export const ListTravelersRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_traveler_service, 4);

/**
 * Describes the message carmen.ListTravelersResponse.
 * Use `create(ListTravelersResponseSchema)` to create a new message.
 */
export const ListTravelersResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_traveler_service, 5);

/**
 * Describes the message carmen.UpdateTravelerRequest.
 * Use `create(UpdateTravelerRequestSchema)` to create a new message.
 */
export const UpdateTravelerRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_traveler_service, 6);

/**
 * Describes the message carmen.UpdateTravelerResponse.
 * Use `create(UpdateTravelerResponseSchema)` to create a new message.
 */
export const UpdateTravelerResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_traveler_service, 7);

/**
 * Describes the message carmen.DeleteTravelerRequest.
 * Use `create(DeleteTravelerRequestSchema)` to create a new message.
 */
export const DeleteTravelerRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_traveler_service, 8);

/**
 * Describes the message carmen.DeleteTravelerResponse.
 * Use `create(DeleteTravelerResponseSchema)` to create a new message.
 */
export const DeleteTravelerResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_traveler_service, 9);

/**
 * @generated from service carmen.TravelerService
 */
export const TravelerService = /*@__PURE__*/
  serviceDesc(file_proto_service_traveler_service, 0);

